import { useState, useEffect, useRef } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams, useHistory, Link } from "react-router-dom";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { authActions } from "../../store/auth";
import { campaignAction } from "../../store/campaign-store";
import cuteAlert, { cuteToast } from "../UI/cute";
import ReactTooltip from "react-tooltip";
import CreatecampaignModals from "../shared/modals/CreatecampaignModals";
import CreatecampaignEzModals from "../shared/modals/CreatecampaignEzModals";
import ImportvideoModals from "../shared/modals/ImportvideoModals";
import CloneModal from "../shared/modals/CloneModal";
import { FaClone } from "react-icons/fa";
import Select from "react-select";
import AntiSpamModals from "../shared/modals/AntiSpamModals";

const Home = () => {
  const { page_no } = useParams();
  const { sendRequest } = useHttp();
  const [campaigns, setCampaigns] = useState([]);
  const [pageLoad, setPageLoad] = useState(true);
  const [count, setCount] = useState();
  const [showCreate, setShowCreate] = useState(false);
  const [showImportvideo, setShowImportvideo] = useState(false);
  const [showClonemodal, setShowClonemodal] = useState(false);
  const [noData, setNoData] = useState(false);
  const [cloneObj, setCloneObj] = useState({
    camp_id: null,
    campaign_name: null,
  });
  const [search, setSearch] = useState();
  const ref = useRef();
  const [sort, setSort] = useState(0);
  
  const history = useHistory();
  const dispatch = useDispatch();
  const isEzModalStatus = useSelector((state) => state.ezleadzStore.isEzModalStatus);
  // console.log(isEzModalStatus);
  const [showCreateEzModal, setShowCreateEzModal] = useState(isEzModalStatus);

  const [showAntiSpamModal, setShowAntiSpamModal] = useState(false);

  const myAccess = useSelector((state) => state.auth.access);

  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  
  const meta_data = useSelector(state => state.auth.product.meta_data)
  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : '';



  useEffect(() => {
    document.title = `${subdomain_name ? subdomain_name : 'Engageleads'} | Dashboard`;
    // if(subdomain_name === 'vidwise'){  
    //   // history.push("/create-campaign");
    // }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[subdomain_name]);

  const responseData = (response) => {
    // console.log(response);

    if (response.content.length > 0) {
      setCampaigns(response.content);
      setCount(response.totalPages);
      setNoData(false);
    } else {
      if (search) {
        setCampaigns([]);
        setCount(0);
        setNoData(true);
      }
    }
    console.log("Calling loader");
    dispatch(authActions.setLoaderStatus({ status: false }));
  };
  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: true }));

    dispatch(campaignAction.setEditorpageLoad({ editor_page_load: false }));

    const page = page_no ? page_no : "";
    // console.log(page_no);

    sendRequest(
      {
        url:
          endPoints.getAllCampaign +
          "/" +
          page +
          ("?sort=" + sort) +
          (search ? "&search=" + search : ""),
        method: "GET",
      },
      responseData
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page_no, pageLoad]);

  useEffect(() => {
    sendRequest(
      {
        url: endPoints.checkTos,
        method: "GET",
      },
      (response) => {
        if (response.status === 200) {
          setShowAntiSpamModal(false);
        }else{
          setShowAntiSpamModal(true);
        }
      }
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = ({ selected }) => {
    // console.log(selected);

    if (selected === 0) {
      history.push("/");
    } else {
      history.push("/dashboard/" + selected);
    }
  };

  const playMovie = (e) => {
    e.target.play();
    // console.log(e);
    e.target.muted = true;
  };

  const stopMovie = (e) => {
    e.target.pause();
    e.target.load();
  };

  const handleDelete = (e, id) => {
    e.preventDefault();

    // return false;

    cuteAlert({
      type: "question",
      title: "Are you sure",
      message: "You cant roll back after delete",
      confirmText: "Delete",
      cancelText: "Cancel",
      img: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/icons/question.svg",
    }).then((e) => {
      if (e === "confirm") {
        sendRequest(
          { url: endPoints.deleteCampaign + "/" + id, method: "DELETE" },
          (response) => {
            if (response.status === 200) setPageLoad(!pageLoad);
          }
        );
      } else {
        cuteToast({
          type: "success",
          message: "",
          timer: 5000,
          title: "Campaign  not deleted!",
        });
      }
    });
  };

  const handleCopyText = (text) => {
    navigator.clipboard.writeText(text);
  };

  const handleRestartRender = (e,camp_id) => {
    e.preventDefault();
    cuteAlert({
      type: "question",
      title: "Are you sure",
      message: "You can restart the render process",
      confirmText: "Yes",
      cancelText: "Cancel",
      img: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/icons/question.svg",
    }).then((e) => {
      if (e === "confirm") {
        sendRequest(
          { url: endPoints.setRestartRender, method: "POST", body: { camp_id } },
          (response) => {
            if (response.status === 200){
              cuteToast({
                type: "success",
                message: "",
                timer: 5000,
                title: "Video added in Queue. Please wait for a while.",
              });
              setTimeout(() => {
                window.location.reload();
              }, 5000);
            }
          }
        );
      } else {
        cuteToast({
          type: "error",
          message: "",
          timer: 5000,
          title: "Video not restarted!",
        });
      }
    });
  }

  /*
    Rebuild or re-init React-tooltip 
  */
  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const handlClick = (event) => {
    event.preventDefault();
    setShowCreate(true);
  };

  const handleClone = (e, camp_id, campaign_name) => {
    e.preventDefault();

    setShowClonemodal(true);
    setCloneObj({ camp_id, campaign_name });
  };

  // search campaign
  const handleSubmit = (e) => {
    e.preventDefault();
    setSearch(ref.current.value);
    dispatch(authActions.setLoaderStatus({ status: true }));

    sendRequest(
      {
        url:
          endPoints.getAllCampaign +
          "/" +
          ("?sort=" + sort) +
          (search ? "&search=" + ref.current.value : ""),
        method: "GET",
      },
      responseData
    );
  };

  const pageLoadClonemodal = (res) => {
    // console.log(res1);

    if (res === 2) {
      setPageLoad(false);
    }
    setShowClonemodal(false);
  };

  const applyPoster = (campaign_data) => {
    if (campaign_data) {
      campaign_data = JSON.parse(campaign_data);

      if (campaign_data.length > 2) {
        return campaign_data[1].thumbnail;
      } else {
        return campaign_data[0].thumbnail;
      }
    }
  };

  const options = [
    { value: 0, label: "All" },
    { value: 1, label: "Completed" },
    { value: 2, label: "Rendering" },
    { value: 3, label: "Draft" },
  ];

  return (
    <>
      <section className="mid_wrap">
        <ReactTooltip />
        <div className="container">
          <div className="row align-items-center mb-4 pb-1">
            <div className="col-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <h3>
                      <a href="#0">Dashboard</a>
                    </h3>
                  </li>
                </ol>
              </nav>
            </div>

            <div className="col-6 d-flex">
              {( campaigns.length > 0 && ( count < 12 || myAccess.includes("5") || myAccess.includes("8A") || myAccess.includes("1a") || myAccess.includes("2A") ) ) && ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                <button className="btn ms-auto" onClick={handlClick}>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/plus.png`}
                    alt="img"
                  />{" "}
                  Create Campaign 
                </button>
              )}
            </div>
          </div>
          {(campaigns.length > 0 || noData) && (
            <>
              <div className="row mb-5">
                <div className=" col-xl-8 col-lg-8 col-md-12 m-auto">
                  <form onSubmit={handleSubmit}>
                    <div className="serach_form_svd">
                      <div className="cl_1">
                        <input
                          name=""
                          type="text"
                          placeholder="Search Campaign"
                          className="text_bx_vd"
                          ref={ref}
                        />
                      </div>
                      <div className="cl_2">
                        <Select
                          options={options}
                          value={options.filter(
                            (option) => option.value === sort
                          )}
                          className="select_bx_vd"
                          onChange={(e) => {
                            setSort(e.value);
                          }}
                        />
                      </div>
                      <div className="cl_3">
                        <input
                          name=""
                          className="btn"
                          type="submit"
                          value="Search"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-none crd mb-4 pb-1">
                <ul>
                  <li>
                    <a href="#0">Completed</a>
                  </li>
                  <li>
                    <a href="#0">Rendering</a>
                  </li>
                  <li>
                    <a href="#0">Draft</a>
                  </li>
                </ul>
              </div>
            </>
          )}

          <div className="row">
            {campaigns.length > 0 &&
              campaigns.map((campaign) => {
                return (
                  <div className="col-xl-4 col-lg-4 col-md-4" key={campaign.id}>
                    <div
                      className={`vd_cl b_solid ${
                        campaign.process_flow === 0 ||
                        campaign.process_flow === 1
                          ? "draft"
                          : campaign.process_flow === 2
                          ? "rendering"
                          : "completed"
                      }`}
                    >
                      {campaign.process_flow <= 2 && (
                        <div className="series_vd position-relative" style={{ backgroundColor:'#bbbbbb',
                        borderRadius: '10px 10px 0px 0px'}}>
                          <img
                            src={applyPoster(campaign.campaign_data)}
                            height='215px'
                            className={ (campaign.template_type !== '' && campaign.template_type === 'VHD') ? 'img_full draft_campignImage_vertical' : (campaign.template_type !== '' && campaign.template_type === 'Box') ? 'img_full draft_campignImage_box' : (campaign.template_type !== '' && campaign.template_type === 'Wide') ? 'img_full draft_campignImage_wide' : 'img_full ' }
                            alt="img"
                          />
                          {campaign.process_flow === 2 ? (
                            <span className="draftstatus pull-right px-2">
                              In Progress
                            </span>
                          ) : (
                            <span className="draftstatus pull-right px-2 bg-warning">
                              Draft
                            </span>
                          )}
                          {/* <a
                            href="#0"
                            className="hvr_play align-items-center justify-content-center"
                          >
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/v_play.png`}
                              alt="img"
                            />
                          </a> */}
                        </div>
                      )}

                      {campaign.process_flow === 3 &&
                        (campaign.video_type === "upload" ||
                          campaign.video_type === "cust_upload") && (
                          <div className="series_vd position-relative" style={{ backgroundColor:'#bbbbbb',borderRadius: '10px 10px 0px 0px'}}>
                            <video
                              // className="video"
                              // className={ (campaign.template_type !== '' && campaign.template_type === 'FHD') ? 'video brdiv' : 'video' }
                              className={ ( campaign.template_type === 'VHD' ) ? 'active_campignImage_vertcal' : ( campaign.template_type === 'Box' ) ? 'active_campignImage_box' : ( campaign.template_type === 'Wide' ) ? 'active_campignImage_wide' : 'active_campignImage_fhd' }
                              src={`${campaign.video_path}${
                                !campaign.poster ? "#t=1.5" : ""
                              }`}
                              poster={`${campaign.poster}`}
                              //   preload="none"
                              loop
                              // height="215"
                              // width="100%"
                              // width={ (campaign.template_type !== '' && campaign.template_type === 'VHD') ? '40%' : '100%' }
                              onMouseOver={playMovie}
                              onMouseOut={stopMovie}
                              // style={{ display: 'block', margin: 'auto'  }}
                            />
                            <span className="draftstatus pull-right px-2 bg-success">
                              Active
                            </span>
                          </div>
                        )}

                      {campaign.process_flow === 3 &&
                        campaign.video_type === "embed" && (
                          <div className="series_vd   position-relative" >
                            <iframe
                              src={campaign.video_path}
                              height="215"
                              width="100%"
                              title={campaign.name}
                            ></iframe>
                            <span className="draftstatus pull-right px-2 bg-success">
                              Active
                            </span>
                          </div>
                        )}

                      {(campaign.process_flow === 0 ||
                        campaign.process_flow === 1 ||
                        campaign.process_flow === 3) && (
                        <>
                          <div className="bdy_vd">
                            <h4 className="pb-2">{campaign.name}</h4>
                            <p className="m-0 cby">
                              <span>Created On:</span>{" "}
                              {new Date(campaign.createdAt).toDateString()}
                            </p>
                          </div>

                          <div className="ftr_vd link_vd text-center">
                            <ul>
                              {campaign.video_path && (
                                <>
                                  <li>
                                    <a
                                      href={campaign.video_path}
                                      download="video.mp4"
                                      target="_blank"
                                      rel="noreferrer"
                                      data-effect="solid"
                                      data-tip="Download Video"
                                    >
                                      <i>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/download.png`}
                                          alt="img"
                                        />
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/download_hv.png`}
                                          alt="img"
                                        />
                                      </i>
                                    </a>
                                  </li>
                                  {/* <li>
                                    <Link
                                      to={campaign.video_path}
                                      download="video.mp4"
                                      target="_blank"
                                      rel="noreferrer"
                                      data-effect="solid"
                                      data-tip="Analytics"
                                    >
                                      <i>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/Analytics.png`}
                                          alt="img"
                                        />
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/Analytics_hv.png`}
                                          alt="img"
                                        />
                                      </i>
                                    </Link>
                                  </li>

                                  <li>
                                    <Link
                                      to={campaign.video_path}
                                      download="video.mp4"
                                      target="_blank"
                                      rel="noreferrer"
                                      data-effect="solid"
                                      data-tip="Mail Stats"
                                    >
                                      <i>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/Mail.png`}
                                          alt="img"
                                        />
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/Mail_hv.png`}
                                          alt="img"
                                        />
                                      </i>
                                    </Link>
                                  </li> */}
                                  {
                                    ( subdomain_name === 'vidwise' ) && (campaign.lead_details) && (
                                    <>
                                    <li>
                                      <a
                                        href={`https://vidwiseai.engageleads.net/mycampaign/${JSON.parse(campaign.lead_details).campid}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-effect="solid"
                                        data-tip={` ${(subdomain_name === 'vidwise')?'Campaign':'Landing Page'} `}
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/landing_black.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/landing_white.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </a>
                                    </li>
                                    
                                    


                                    <li>
                                      <a
                                        href={`https://vidwiseai.engageleads.net/createPage?insert_place_id=${JSON.parse(campaign.lead_details).campid}&video_url=${campaign.video_path}`}
                                        target="_blank"
                                        data-effect="solid"
                                        rel="noreferrer"
                                        data-tip="Landing Page"
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/eye.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/eye_hv.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </a>
                                    </li>
                                    </>
                                    )
                                  }
                                  
                                  
                                  {
                                    ( subdomain_name === 'nicheflick' ) && (campaign.lead_details) && (
                                    <>
                                    <li>
                                      <a
                                        href={`https://nicheflicks.engageleads.net/mycampaign/${JSON.parse(campaign.lead_details).campid}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-effect="solid"
                                        data-tip={` ${(subdomain_name === 'nicheflick')?'Campaign':'Landing Page'} `}
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/landing_black.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/landing_white.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </a>
                                    </li>
                                    
                                    


                                    <li>
                                      <a
                                        href={`https://nicheflicks.engageleads.net/createPage?insert_place_id=${JSON.parse(campaign.lead_details).campid}&video_url=${campaign.video_path}`}
                                        target="_blank"
                                        data-effect="solid"
                                        rel="noreferrer"
                                        data-tip="Landing Page"
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/eye.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/eye_hv.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </a>
                                    </li>
                                    </>
                                    )
                                  }

                                  {
                                    ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                                    
                                    <li>
                                      <Link
                                        to={`/video/view/${campaign.id}`}
                                        rel="noreferrer"
                                        data-effect="solid"
                                        data-tip="Personlize video"
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/Magic.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/Magic_hv.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </Link>
                                    </li>
                                    )
                                  }
                                  {
                                    ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                                    <li>
                                      <Link
                                        to={{
                                          pathname:
                                            "/" + campaign.id + "/edit-landing",
                                          state: { fromPersonalize: true },
                                        }}
                                        data-effect="solid"
                                        data-tip="Landing Page"
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/landing_black.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/landing_white.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </Link>
                                    </li>
                                    )
                                  }
                                  {
                                    ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                                    <li>
                                      <Link
                                        to={{
                                          pathname:
                                            "/campaign/analytics/" + campaign.id,
                                          state: { fromDashboard: true },
                                        }}
                                        data-effect="solid"
                                        data-tip="Analytics"
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/analytics_black.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/analytics_white.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </Link>
                                    </li>
                                    )
                                  }
                                  {
                                    ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                                    <li>
                                      <a
                                        href={`https://vidcraftai.vidconnect.net/page/${campaign.id}`}
                                        target="_blank"
                                        data-effect="solid"
                                        rel="noreferrer"
                                        data-tip="Preview Landing Page"
                                      >
                                        <i>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/eye.png`}
                                            alt="img"
                                          />
                                          <img
                                            src={`${process.env.PUBLIC_URL}/assets/images/eye_hv.png`}
                                            alt="img"
                                          />
                                        </i>
                                      </a>
                                    </li>
                                    )
                                  }
                                  {
                                    ( subdomain_name !== 'vidwise' ) && ( subdomain_name !== 'nicheflick' ) && (
                                    <li>
                                      <Link
                                        to="0#"
                                        onClick={(e) => {
                                          handleClone(
                                            e,
                                            campaign.id,
                                            campaign.name
                                          );
                                        }}
                                        data-effect="solid"
                                        data-tip="Clone Campaign"
                                        className="cloneCampaign"
                                      >
                                        <i>
                                          <FaClone />
                                        </i>
                                      </Link>
                                    </li>
                                    )
                                  }

                                  
                                </>
                              )}

                              {campaign.process_flow <= 1 && (
                                <li>
                                  <Link
                                    to={`/campaign/${campaign.id}/edit`}
                                    data-effect="solid"
                                    data-tip="Edit"
                                  >
                                    <i>
                                      <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/edit.png`}
                                        alt="img"
                                      />
                                      <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/edit_hv.png`}
                                        alt="img"
                                      />
                                    </i>
                                  </Link>
                                </li>
                              )}
                              <li>
                                <Link
                                  to="#0"
                                  onClick={(e) => handleDelete(e, campaign.id)}
                                  data-effect="solid"
                                  data-tip="Delete Campaign"
                                  data-type="error"
                                >
                                  <i>
                                    <img
                                      src={`${process.env.PUBLIC_URL}/assets/images/delete.png`}
                                      alt="img"
                                    />
                                    <img
                                      src={`${process.env.PUBLIC_URL}/assets/images/delete_hv.png`}
                                      alt="img"
                                    />
                                  </i>
                                </Link>
                              </li>
                              {campaign.process_flow === 0 && campaign.rendered_info && (
                                  <li>
                                    <Link
                                      data-effect="solid"
                                      data-tip={` Copy Error Message`}
                                      onClick={ () => handleCopyText(campaign.rendered_info)}
                                    >
                                      <i>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/clone.png`}
                                          alt="img"
                                        />
                                        <img
                                          src={`${process.env.PUBLIC_URL}/assets/images/clone.png`}
                                          alt="img"
                                        />

                                      </i>
                                    </Link>
                                  </li>
                              )}
                            </ul>
                          </div>
                        </>
                      )}

                      {campaign.process_flow === 2 && (
                        <div className="bdy_vd">
                          <h4 className="pb-2">{campaign.name}</h4>
                          <p className=" cby">
                            <span>Created On:</span>{" "}
                            {new Date(campaign.createdAt).toDateString()}
                          </p>
                          <div className="progress mb-3">
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{ width: campaign.render_progress + "%" }}
                              aria-valuenow="60"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                          <NavLink
                            to={`/render/${campaign.id}`}
                            className="btn btn2 w-100"
                          >
                            View Render
                          </NavLink>
                          { console.log(campaign) }
                          { myAccess && myAccess.includes("5") && (new Date(campaign.updatedAt) < new Date(new Date().getTime() - (30 * 60 * 1000))) && (
                          <button
                            className="btn btn-info w-100 mt-2"
                            data-effect="solid"
                            data-tip="Click to restart render video"
                            onClick={(e) => handleRestartRender(e,campaign.id)}
                          >
                            Restart Render
                          </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}

            {campaigns.length === 0 && !noData && (
              <div className="emptyDiv">
                <h3>
                  <b>Welcome to {subdomain_name} Dashboard</b>
                </h3>
                { logo && <img
                  src={logo}
                  className="img-fluid"
                  alt="img"
                  />
                }

                <h5 className="mt-4">
                  <b>You have not created campaign yet!</b>
                </h5>
                <p className="mt-4">
                  <b>All your created campaigns will be saved here</b>
                </p>

                <button className="btn mt-4" onClick={handlClick}>
                  Create Your First Campaign
                </button>
              </div>
            )}

            {noData && (
              <div className="emptyDiv">
                <h5>
                  <b>No Campaign's Found of keyword "{search}"</b>
                </h5>
                <button className="btn mt-2" onClick={handleSubmit}>
                  Show All
                </button>
              </div>
            )}
          </div>
          {count > 0 && (
            <nav aria-label="...">
              <ReactPaginate
                previousLabel={"<<"}
                nextLabel={">>"}
                pageCount={count}
                onPageChange={handlePageChange}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                activeClassName={"active"}
                previousClassName={"page-item"}
                breakClassName={"page-item"}
                nextClassName={"page-item"}
                previousLinkClassName={"page-link"}
                breakLinkClassName={"page-link"}
                nextLinkClassName={"page-link"}
                marginPagesDisplayed={2}
                disabledClassName={"d-none"}
                initialPage={page_no ? parseInt(page_no) : ""}
              />
            </nav>
          )}
        </div>

        {showCreate && (
          <>
            <CreatecampaignModals
              setShowCreate={setShowCreate}
              setShowImportvideo={setShowImportvideo}
            />
            <div className="modal-backdrop fade show"></div>
          </>
        )}

        {showClonemodal && (
          <>
            <CloneModal
              cloneObj={cloneObj}
              setShowClonemodal={pageLoadClonemodal}
            />
            <div className="modal-backdrop fade show"></div>
          </>
        )}

        {showImportvideo && (
          <>
            <ImportvideoModals
              setShowCreate={setShowCreate}
              setShowImportvideo={setShowImportvideo}
            />
            <div className="modal-backdrop fade show"></div>
          </>
        )}

        {showCreateEzModal && (
          <>
            <CreatecampaignEzModals
              setShowCreateEzModal={setShowCreateEzModal}
              setShowImportvideo={setShowImportvideo}
            />
            <div className="modal-backdrop fade show"></div>
          </>
        )}

        {showAntiSpamModal && ( 
          <>
            <AntiSpamModals setShowAntiSpamModal={setShowAntiSpamModal}/>
            <div className="modal-backdrop fade show"></div>
          </>  
        )}
      </section>
    </>
  );
};

export default Home;
